import { Skeleton } from '@heroui/react'
import React from 'react'

const NftStakingCardLoader = () => {
  return (
    <div className="card bg-black rounded-2xl p-3 cursor-pointer">
      <div className="relative flex flex-col justify-end">
        <Skeleton className="w-full h-[8.375rem] rounded-xl dark">
        </Skeleton>
        <div className="card-content rounded-lg bg-[#000000E5] mt-4">
          <Skeleton className="w-[80%] h-3 rounded-md dark">
          </Skeleton>
          <Skeleton className="w-[50%] h-3 mt-1 rounded-md dark">
          </Skeleton>
          <div className="flex items-center justify-between gap-2 mt-4">
            <Skeleton className="flex-1 w-full h-8 rounded-lg dark">
            </Skeleton>
            <Skeleton className="flex-1 w-full h-8 rounded-lg dark">
            </Skeleton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NftStakingCardLoader
